import type { ITemplate } from '../../../../../notifications';
import { Button } from '../../../../../../components/Common/UI/Button';
import Icons from '../../../../../../components/Common/Icons/Icons';

interface IProps {
  email: ITemplate;
}

function EmailContent({ email }: IProps) {
  return (
    <div className="p-[10px_0_40px_75px]">
      {email?.contentHTML ? (
        <div
          className="html-email-content max-w-[845px] text-[13px] leading-[18px]"
          dangerouslySetInnerHTML={{ __html: email?.contentHTML as string }}
        />
      ) : null}
      <div className="flex gap-[10px] mt-[20px]">
        <Button
          className="rounded-[20px] border-addition11 h-[38px] text-[14px] font-medium border-[1px]
          items-center gap-[5px] !bg-white !text-addition11 px-[20px] py-[0]"
        >
          <Icons.Reply />
          Reply
        </Button>
        <Button
          className="rounded-[20px] border-addition11 h-[38px] text-[14px] font-medium border-[1px]
          items-center gap-[5px] !bg-white !text-addition11 px-[20px] py-[0]"
        >
          <Icons.Reply className="scale-x-[-1]" />
          Forward
        </Button>
      </div>
    </div>
  );
}

export default EmailContent;
